var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "listing-settings-header" },
    [
      _vm.searchable
        ? _c("CompassInput", {
            staticClass: "listing-settings-header__utils-search",
            attrs: {
              value: _vm.searchValue,
              placeholder: _vm.$t.__("common.labels.search"),
              prefixIcon: "search"
            },
            on: { "update:value": _vm.updateSearchValue },
            scopedSlots: _vm._u(
              [
                {
                  key: "suffix",
                  fn: function() {
                    return [
                      _c("CompassIconButton", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.searchValue.length > 0,
                            expression: "searchValue.length > 0"
                          }
                        ],
                        staticClass:
                          "listing-settings-header__utils-search-reset",
                        attrs: { size: "small", icon: "close" },
                        on: {
                          click: function($event) {
                            return _vm.updateSearchValue("")
                          }
                        }
                      })
                    ]
                  },
                  proxy: true
                }
              ],
              null,
              false,
              452187573
            )
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.searchable && _vm.filters.length > 0
        ? _c("div", { staticClass: "listing-settings-header__divider" })
        : _vm._e(),
      _vm._v(" "),
      _vm.filters.length > 0
        ? _c(
            "div",
            { staticClass: "listing-settings-header__filters-container" },
            [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.hasActiveFilters,
                      expression: "hasActiveFilters"
                    }
                  ],
                  staticClass: "listing-settings-header__filters-tags"
                },
                [_vm._t("filters")],
                2
              ),
              _vm._v(" "),
              _c(
                "CompassMenu",
                {
                  staticClass: "listing-settings-header__filters-select",
                  attrs: {
                    trigger: "click",
                    customClass:
                      "listing-settings-header__filters-select-dropdown"
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "dropdown",
                        fn: function() {
                          return _vm._l(_vm.filters, function(filter) {
                            return _c("CompassMenuItem", {
                              key:
                                "listing-settings-header__filtres-" +
                                filter.code,
                              attrs: { label: filter.label },
                              on: {
                                click: function($event) {
                                  return _vm.onFilterSelected(filter)
                                }
                              }
                            })
                          })
                        },
                        proxy: true
                      }
                    ],
                    null,
                    false,
                    3375588623
                  )
                },
                [
                  _c("CompassPlainButton", {
                    attrs: {
                      label: _vm.$t.__("common.labels.add_filter"),
                      variant: "neutral",
                      leftIcon: "plus"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "listing-settings-header__utils-container" },
        [
          _vm.displayTotalResults
            ? _c(
                "span",
                {
                  staticClass:
                    "typographies-paragraph-medium-bold listing-settings-header__utils-total-results"
                },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.textTotalResults) +
                      "\n        "
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.refreshable
            ? _c(
                "CompassTooltip",
                {
                  attrs: {
                    content: _vm.$t.__("common.actions.refresh"),
                    placement: "top-end"
                  }
                },
                [
                  _c("CompassIconButton", {
                    attrs: { type: "secondary", icon: "reload" },
                    on: { click: _vm.handleRefresh }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.enableColumnsSettings
            ? _c("ListingSettings", {
                attrs: { searchableColumns: _vm.searchableColumns },
                on: { updateColumns: _vm.updateColumns }
              })
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }